import {EstimateWithClientDto} from "../../../shared/dtos/estimate-with-client.dto";

export interface AppointmentDto {
  id: number;
  companyId: number;
  status: AppointmentStatusType;
  time: Date;
  clientId: number;
  clientName: string;
  clientPhoneNumber?: string;
  clientEmail?: string;
  clientAddress: string;
  estimateId: number;
  estimateAddress: string;
  estimateCity: string;
  estimateState: string;
  estimatePostalCode: string;
  estimateLat: number;
  estimateLng: number;
  notes?: string;
  createdBy: number
  createdAt: string;
  updatedAt: string;
}

export interface AppointmentDetailDto {
  id: number;
  companyId: number;
  time?: Date;
  notes?: string;
  estimateWithClient: EstimateWithClientDto;
  createdBy: number
  createdAt: string;
  updatedAt: string;
}

export interface CreateAppointmentDto {
  time?: Date;
  status?: AppointmentStatusType;
  clientId?: number;
  clientName?: string;
  clientPhoneNumber?: string;
  clientEmail?: string;
  estimateAddress: string;
  estimateCity: string;
  estimateState: string;
  estimatePostalCode: string;
  estimateLat: number;
  estimateLng: number;
  notes?: string;
  /** SQ-426: the client's Additional Client Info entries this record is for; none means the client's own. */
  contactNameId?: number;
  contactPhoneId?: number;
  contactAddressId?: number;
  contactEmailId?: number;
}

export interface UpdateAppointmentDto {
  time?: Date;
  status?: AppointmentStatusType;
  clientName?: string;
  clientPhoneNumber?: string;
  clientEmail?: string;
  estimateAddress?: string;
  estimateCity?: string;
  estimateState?: string;
  estimatePostalCode?: string;
  estimateLat?: number;
  estimateLng?: number;
  notes?: string;
}

export const AppointmentStatus = {
  Draft: 'Draft',
  Active: 'Active',
  Completed: 'Completed',
  PendingReschedule: 'PendingReschedule',
  Cancelled: 'Cancelled'
} as const;

export type AppointmentStatusType = typeof AppointmentStatus[keyof typeof AppointmentStatus];

/** List/table labels. Backend still uses Draft / Active / PendingReschedule. */
export function appointmentStatusLabel(status: AppointmentStatusType): string {
  switch (status) {
    case AppointmentStatus.Cancelled:
      return 'Cancelled';
    case AppointmentStatus.Completed:
      return 'Completed';
    default:
      return 'New';
  }
}